export default "__VITE_ASSET__9c76dba0__"